"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionsForEachSymptom = void 0;
const firestore_1 = require("firebase/firestore");
const react_query_1 = require("react-query");
const keyFactory_1 = require("../keyFactory");
function removeDuplicatesById(arr) {
    const uniqueItems = arr.reduce((acc, curr) => {
        const itemExists = acc.some((item) => item.id === curr.id);
        if (!itemExists) {
            acc.push(curr);
        }
        return acc;
    }, []);
    return uniqueItems;
}
async function getQuestionsForEachSymptom(firestore, selectedSymptomsLowercase, sex) {
    const selectedQuestions = [];
    const questionsReference = (0, firestore_1.collection)(firestore, "/parametros/userapp", "assessment");
    const allQuestions = [];
    const questionsQuery = await (0, firestore_1.getDocs)(questionsReference);
    questionsQuery.forEach((questionQuery) => {
        if (questionQuery.exists()) {
            const questionData = questionQuery.data();
            allQuestions.push({
                id: questionQuery.id,
                ...questionData,
            });
        }
    });
    const firstQuestions = allQuestions.filter((question) => {
        return question.triggers.some((trigger) => selectedSymptomsLowercase.includes(trigger));
    });
    selectedQuestions.push(...firstQuestions);
    const symptoms = [
        ...new Set(firstQuestions.map((doc) => doc.symptom)),
    ].flat();
    const features = [
        ...new Set(firstQuestions.map((doc) => doc.features)),
    ].flat();
    const secondQuestions = allQuestions.filter((question) => {
        return symptoms.some((symptomId) => symptomId === question.id);
    });
    const thirdQuestions = allQuestions
        .filter((question) => {
        return (features.some((featuresId) => featuresId === question.id) &&
            (!question.sex || question.sex === sex?.toLowerCase()));
    })
        .map((question) => ({ ...question, showSkip: true }));
    selectedQuestions.push(...secondQuestions);
    selectedQuestions.push(...thirdQuestions);
    return removeDuplicatesById(selectedQuestions).map((question) => ({
        id: question.id,
        answer: question.answer.map((a) => {
            return { ...a };
        }),
        input: question.input,
        question: question.question,
        showSkip: question.showSkip,
    }));
}
exports.getQuestionsForEachSymptom = getQuestionsForEachSymptom;
function useGetQuestionsForEachSymptom(firestore, selectedSymptomsLowercase, sex, QueryOptions) {
    return (0, react_query_1.useQuery)(keyFactory_1.FirestoreKeys.Guardia({
        name: "GuardQuestions",
        path: "parametros/userapp/assessment"
    }, selectedSymptomsLowercase), async () => {
        return getQuestionsForEachSymptom(firestore, selectedSymptomsLowercase, sex);
    }, QueryOptions);
}
exports.default = useGetQuestionsForEachSymptom;
